import { getInitials } from '@/shared/lib/names';
import { Avatar } from '@heroui/react';

export function NameAvatar({
  value,
  size = 'sm',
  className,
}: {
  value: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}) {
  const sizes = {
    sm: 'text-sm',
    md: 'text-medium',
    lg: 'text-lg',
    xl: 'text-xl',
  };

  const initials = getInitials(value);
  const sizeClass = sizes[size];
  const avatarSize = { sm: 'sm', md: 'md', lg: 'lg', xl: 'lg' }[size] as
    | 'sm'
    | 'md'
    | 'lg'
    | undefined;

  return (
    <Avatar
      alt={value}
      name={initials}
      className={`bg-primary-500 text-white ${sizeClass} ${className}`}
      size={avatarSize}
    />
  );
}

export function Name({
  value,
  size = 'sm',
  className,
}: {
  value: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}) {
  const sizes = {
    sm: 'text-md',
    md: 'text-lg',
    lg: 'text-xl font-medium',
    xl: 'text-2xl font-medium',
  };
  const sizeClass = sizes[size] || 'text-2xl font-medium';

  return (
    <div className={`my-1 flex flex-row items-center ${className}`}>
      <NameAvatar value={value} size={size} />
      <p className={`ml-2 flex-grow ${sizeClass}`}>{value}</p>
    </div>
  );
}
